import React from 'react'
import { useIntl } from 'react-intl'
import { DialogTitle, DialogContent, Box, Typography } from '@mui/material'

import { EditClientForm } from '../edit-client-form'

export const EditClientDialog = (props) => {
  const { formatMessage } = useIntl()
  console.log('EditClientDialog props:', props)
  return (
    <Box p={2}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="h5" color="textSecondary">
            {formatMessage({ id: 'pages.application.detail.dialogs.editClient.title' })}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <EditClientForm {...props} />
      </DialogContent>
    </Box>
  )
}
